/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { Modal, Row, Col, Form, Button, InputGroup } from 'react-bootstrap'
import { DateTimePicker, RichTextEditor } from '@components/common'
import { TOOLBAR_ITEMS } from '@constants/Tasks'
import { patientList, providerList } from '@assets/mockdata'

type CreateEditTaskProps = {
  isOpen: boolean
  toggleModal: () => void
  action: 'create' | 'edit'
  data: any
}

function CreateEditTask({
  isOpen,
  toggleModal,
  action,
  data,
}: CreateEditTaskProps): React.ReactElement {
  const [description, setDescription] = useState('')
  const [assignTo, setAssignTo] = useState('')
  const [taskFor, setTaskFor] = useState('')
  const [startDate, setStartDate] = useState('')
  const [dueDate, setDueDate] = useState('')
  const [priorityLevel, setPriorityLevel] = useState('')

  useEffect(() => {
    if (action === 'edit') {
      setDescription(data.description || '')
      setAssignTo(data.assignedTo || '')
      setStartDate(data.startDate || '')
      setDueDate(data.dueDate || '')
      setPriorityLevel(data.priority || '')
      setTaskFor(data.patientId || '')
    } else if (action === 'create') {
      // Reset all states when creating a new task
      setDescription('')
      setAssignTo('')
      setStartDate('')
      setDueDate('')
      setPriorityLevel('')
      setTaskFor('')
    }
  }, [data, action])

  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="bg-custom3 text-dark" closeButton>
        {`${action === 'create' ? 'Create' : 'Edit'} Task`}
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12} className="mb-3">
            <Form>
              <Form.Label>Task description</Form.Label>
              <RichTextEditor
                key="create-edit-task"
                content={description}
                handleContentChange={(desc) => setDescription(desc)}
                toolbarItems={TOOLBAR_ITEMS}
              />
            </Form>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Task for</Form.Label>
              <InputGroup>
                <Form.Select
                  value={taskFor}
                  onChange={(e) => setTaskFor(e.target.value)}
                >
                  {patientList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {`${item.firstname} ${item.lastname}`}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Assign to</Form.Label>
              <InputGroup>
                <Form.Select
                  value={assignTo}
                  onChange={(e) => setAssignTo(e.target.value)}
                >
                  {providerList.map((item) => (
                    <option key={item.providerId} value={item.providerId}>
                      {`${item.firstname} ${item.lastname}`}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </Col>

          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Start date</Form.Label>
              <DateTimePicker
                title="edit-create-task-start-date"
                value={startDate}
                onChange={(date) => setStartDate(date)}
                placeholder="MM/DD/YYYY hh:mm:ss"
                format="MM/dd/yyyy hh:mm:ss"
                openOnFocus={true}
                strictMode={true}
                showTodayButton={false}
              />
            </Form.Group>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Group>
              <Form.Label>Due date</Form.Label>
              <DateTimePicker
                title="edit-create-task-due-date"
                value={dueDate}
                onChange={(date) => setDueDate(date)}
                placeholder="MM/DD/YYYY hh:mm:ss"
                format="MM/dd/yyyy hh:mm:ss"
                openOnFocus={true}
                strictMode={true}
                showTodayButton={false}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Priority level</Form.Label>
              <InputGroup>
                <Form.Select
                  value={priorityLevel}
                  onChange={(e) => setPriorityLevel(e.target.value)}
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                </Form.Select>
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="button button-primary" onClick={toggleModal}>
          {`${action === 'create' ? 'Create' : 'Update task'}`}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateEditTask
